import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

function Footer() {
    const footerRef = useRef(null);
const [isVisible, setIsVisible] = useState(false);

useEffect(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    },
    {
      threshold: 0.2,
    }
  );

  if (footerRef.current) {
    observer.observe(footerRef.current);
  }

  return () => observer.disconnect();
}, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
   <footer
  ref={footerRef}
  className={`site-footer footer-animate ${isVisible ? "show" : ""}`}
>
      <div className="footer-glow footer-glow-one"></div>
      <div className="footer-glow footer-glow-two"></div>

      <div className="footer-container">
        <div className="footer-columns">
          <div className="footer-column footer-brand-column">
            <h3>چشم هوشمند آموزش</h3>

            <p>
             چشم هوشمند آموزش با هدف ارائه آموزش‌های کاربردی، به‌روز و قابل‌اعتماد در حوزه فناوری اطلاعات، شبکه، امنیت، برنامه‌نویسی، هوش مصنوعی و مهارت‌های دیجیتال فعالیت می‌کند. ما تلاش می‌کنیم با ترکیب دانش تخصصی، تجربه عملی و محتوای آموزشی ساختارمند، مسیر یادگیری را برای علاقه‌مندان، دانشجویان، متخصصان و کسب‌وکارها ساده‌تر و مؤثرتر کنیم تا هر فرد بتواند متناسب با نیاز خود، مهارت‌های لازم برای ورود، رشد و موفقیت در دنیای فناوری را به دست آورد.
            </p>

            <Link to="/admin/login" className="footer-staff-btn">
              ورود پرسنل
            </Link>
          </div>

         <div className="footer-column">
  <h4>صفحات سایت</h4>

  <ul>
    <li>
      <Link to="/">خانه</Link>
    </li>

    <li>
      <Link to="/news">اخبار</Link>
    </li>

    <li>
      <Link to="/courses">دوره‌ها</Link>
    </li>

    <li>
      <a href="https://iemict.com" target="_blank" rel="noreferrer">
        شرکت مادر
      </a>
    </li>

    <li>
      <Link to="/about">درباره ما</Link>
    </li>

    <li>
      <Link to="/contact">تماس با ما</Link>
    </li>
  </ul>
</div>

          <div className="footer-column">
            <h4>انواع خدمات ما</h4>

            <ul>
              <li>آموزش فناوری اطلاعات</li>
              <li>انتشار اخبار تخصصی تکنولوژی</li>
              <li>برنامه نویسی و توسعه نرم افزار</li>
              <li>ارائه مسیرهای یادگیری حرفه‌ای</li>
              <li>مشاوره تخصصی شبکه </li>
              <li>دوربین های مداربسته</li>
              <li>سرور و دیتاسنتر</li>
              <li>سیستم پیجینگ</li>
              <li>طراحی سایت</li>
              <li>VOIP</li>
              <li>GPON</li>

            </ul>
          </div>

          <div className="footer-column">
            <h4>راه‌های ارتباطی</h4>

            <ul className="footer-contact-list">
              <li>
                <span>ایمیل:</span>
                <a href="mailto:info@iemict.com">info@iemict.com</a>
                <a href="mailto:iemict@iran.ir">iemict@iran.ir</a>
            
              </li>

              <li>
                <span>تلفن:</span>
                <a href="tel:+982191313513">02191313513</a>
                <a href="tel:+989120381360">09120381360</a>
              </li>

              <li>
                <span>وب‌سایت: </span>
                <a href="https://iemict.com" target="_blank" rel="noreferrer">
                  iemict.com
                </a>
              </li>

              <li>
                <span>آدرس:</span>
                 <span>شعبه تهران: تهران، چهارراه فرمانیه، ابتدای نارنجستان هفتم، پلاک44، مجتمع اداری تجاری A1 فرمانیه</span>
                <span>دفتر مرکزی: کرج، چهار راه كارخانه قند، خيابان زكريا رازی، مجتمع اداری مشتاق، واحد 11</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-back-top-row">
          <button type="button" className="footer-back-top" onClick={scrollToTop}>
            بازگشت به بالا
          </button>
        </div>

        <div className="footer-bottom">
          <p>
            تمامی حقوق این وبسایت برای چشم هوشمند آموزش محفوظ می‌باشد. 2026
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;